export default __webpack_public_path__ + "static/media/apvs-arte-3.122d09f9.webp";